module.exports = __webpack_public_path__ + "media/one_wish.684623f9.mp3";